module.exports = __webpack_public_path__ + "cecba78c303b674016c9d24a34849691.pdf";